import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { UserActionComponent } from '../user-action/user-action.component';

import { DefaultMira, ItemType, OnAirItem } from '@irohalab/mira-sdk-angular';
import { Subscription } from 'rxjs';
import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-home',
    imports: [
    NavbarComponent,
    UserActionComponent,
    RouterLink,
    UIResponsiveImageWrapper,
    SidebarComponent
],
    templateUrl: './home.component.html',
    styleUrl: './home.component.less'
})
export class HomeComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  onAirItemList!: OnAirItem[];

  constructor(private miraApiService: DefaultMira) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.miraApiService.onAirItem(ItemType.Anime)
        .subscribe((data) => {
          this.onAirItemList = data.data;
          // console.log(data.data);
        })
    );

    // this.subscription.add(
    //   this.miraApiService.listMainItems('Item')
    //     .subscribe((data) => {
    //       console.log(data);
    //     })
    // );
  }

}
